// src/api/book.ts
const API_BASE = process.env.REACT_APP_INGEST_API_BASE || 'http://localhost:3001';

export type TopLevel = { side: 'bid'|'ask'; price: number; total_size: number };

export async function fetchTopLevels(
  symbol: string,
  depth = 10,
  side: 'bid'|'ask'|'both' = 'both'
) {
  const u = new URL(`${API_BASE}/api/book/${encodeURIComponent(symbol)}/levels`);
  u.searchParams.set('depth', String(depth));
  u.searchParams.set('side', side);
  const r = await fetch(u.toString());
  if (!r.ok) throw new Error('levels failed');
  return r.json() as Promise<{
    symbol: string;
    depth: number;
    bids: Array<{ price: number; size: number }>;
    asks: Array<{ price: number; size: number }>;
  }>;
}
